import styled from 'styled-components';
import tinycolor from 'tinycolor2';

type BrandTintIconBadgeProps = {
  $size?: number;
};

export const BrandTintIconBadge = styled.div<BrandTintIconBadgeProps>`
  align-items: center;
  /* tinycolor.mix() is a JS-computed, tenant-brand-derived color - it can't be
     expressed as a CSS var() fallback, so the Concierge override below uses
     CSS color-mix() instead (higher specificity, wins the cascade) to blend
     against the dark surface rather than white. */
  background-color: ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).toString()};
  .concierge-mode & {
    background-color: color-mix(in oklab, var(--dcm-concierge-accent) 10%, var(--dcm-color-surface-muted));
  }
  border-radius: 50%;
  color: var(--dcm-color-primary, ${({ theme }) => theme.customized.colors.buttonsLinks});
  display: flex;
  flex-shrink: 0;
  height: ${({ $size = 40 }) => $size}px;
  justify-content: center;
  width: ${({ $size = 40 }) => $size}px;
`;
